import BasicFormInput from '../../Components/BasicFormInput/BasicFormInput';
import classesCss from './BasicFormInputs.module.css';

const BasicFormInputs = ({labels, css, register}) => {
	return (
		<div className={`${classesCss.container} ${css}`}>
			{
				labels.map((label, idx) => <BasicFormInput label={label} key={idx} register={register}/>)
			}
		</div>
	);
};

export default BasicFormInputs;
